/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hint_Command_PaletteInputs */

const en_hint_command_palette = /** @type {(inputs: Hint_Command_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command palette`)
};

const de_hint_command_palette = /** @type {(inputs: Hint_Command_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befehlspalette`)
};

/**
* | output |
* | --- |
* | "Command palette" |
*
* @param {Hint_Command_PaletteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const hint_command_palette = /** @type {((inputs?: Hint_Command_PaletteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hint_Command_PaletteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_hint_command_palette(inputs)
	return en_hint_command_palette(inputs)
});